import { defineComponent as _defineComponent } from 'vue'
import {
	withDefaults,
	computed,
	ComputedRef,
} from "vue";

import borderVertical from "@/vue/common/borderVertical";
import store from "@/vue/planning/store/store";
import Prices from "@/vue/planning/components/common/prices.vue";
import SelectButton from "@/vue/planning/components/result/selectBtn.vue";
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";
import {
	getPrestCrossedPrice,
	getPrestTotalPrice,
	// getPrestPerPrice,
	getPrestMaxPromo,
} from "@/logic/pricesAndDiscount";
import responsesCache from "@/vue/planning/state/responsesCache";
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet";
import currentCacheKey from "@/vue/planning/computed/currentCacheKey";

interface Props {
	variant: any;
}
interface Emits {
	(e: "select", id: string): void;
	(e: "clear", id: string): void;
	(
		e: "dropdownSelect",
		selectedData: { newSelected: number; id: string }
	): void;
	(e: "dropdownClick", obj: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PrestPopupVariantDefault',
  props: {
    variant: { default: {} }
  },
  emits: ["select", "clear", "dropdownSelect", "dropdownClick"],
  setup(__props: any, { emit }: { emit: ({
	(e: "select", id: string): void;
	(e: "clear", id: string): void;
	(
		e: "dropdownSelect",
		selectedData: { newSelected: number; id: string }
	): void;
	(e: "dropdownClick", obj: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { variant: any }




const crossedPrice: ComputedRef<number> = computed(() => {
	if (!props.variant) return NaN;
	const pricesResponse = responsesCache.value.getResponse(
		"prices",
		currentCacheKey.value
	);
	return props.variant && getPrestCrossedPrice(props.variant, !!pricesResponse);
});

const perPrice: ComputedRef<number> = computed(() => {
	return NaN;
	// return props.variant && getPrestPerPrice(props.variant, this.participants.length)
});

const totalPrice: ComputedRef<number> = computed(() => {
	return props.variant && getPrestTotalPrice(props.variant);
});

const maxPromo: ComputedRef<number> = computed(() => {
	return props.variant && getPrestMaxPromo(props.variant);
});

return { __sfc: true,props, emit, crossedPrice, perPrice, totalPrice, maxPromo, store, Prices, SelectButton, Inclus, pricesLoadingSet, currentCacheKey }
}

})